import { Flex, Heading, useMediaQuery } from '@chakra-ui/react'
import type { Dispatch, ReactElement, SetStateAction } from 'react'

import CourseFilters from '@/components/Course/CourseFilters/CourseFilters'
import { largeScreen } from '@/components/UI/common.styled'

export default function CourseResultsAllHeader({
  disabled,
  setPageDisabled,
}: {
  disabled: boolean
  setPageDisabled: Dispatch<SetStateAction<boolean>>
}): ReactElement {
  const [isLgPlus] = useMediaQuery(`(min-width: ${largeScreen})`)

  return (
    <Flex
      flexDir="column"
      position="sticky"
      top="64px"
      zIndex={2}
      boxShadow="0px 5px 3px -3px rgba(0, 0, 0, 0.15)"
      py={3}
      bgColor="bg"
    >
      <Flex flexDir="row" alignItems="center" mb={3}>
        <Heading size="xl" as="h3" my={0} fontWeight="bold">
          Upcoming in All Courses
        </Heading>
      </Flex>
      {!isLgPlus ? (
        <CourseFilters isModal disabled={disabled} setPageDisabled={setPageDisabled} />
      ) : null}
    </Flex>
  )
}
